'use client';

import { Outlet } from 'react-router-dom';
import { AdminTabBar } from '@/components/layout/admin-tab-bar';

export default function AdminLayout() {
	return (
		<div>
			<AdminTabBar />
			<Outlet />
		</div>
	);
}
